module.exports = __webpack_public_path__ + "img/mdm-deploy-1.365c8ea5.webp";